import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token =
    searchParams.get('token') ||
    (typeof window !== 'undefined' ? localStorage.getItem('token') : null) ||
    Cookies.get('token');

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
